import React from "react"
import types from "prop-types"
import EllipsisIcon from "shared/icons/EllipsisIcon"

const ExpandMenuEllipsisButton = ({
  ariaLabel = "show menu", className = "", iconClassName = "", isOpen = false, ref = undefined, ...rest
}) => (
  <button
    aria-haspopup
    aria-expanded={isOpen}
    aria-label={ariaLabel}
    {...rest}
    ref={ref}
    className={className}
  >
    <EllipsisIcon className={iconClassName} ariaHidden />
  </button>
)

ExpandMenuEllipsisButton.propTypes = {
  ariaLabel: types.string,
  className: types.string,
  iconClassName: types.string,
  isOpen: types.bool,
  ref: types.oneOfType([types.func, types.object]),
}

ExpandMenuEllipsisButton.displayName = "ExpandMenuEllipsisButton"

export default ExpandMenuEllipsisButton
